import { IMAGE_UUID_ATTRIBUTE } from '@core/constants/ACTIVES';

/**
 * Searcher constants. They are used in the searcher.
 * @type {{
 *  IMAGE_ID: string,
 *  TYPE: string,
 *  TEXT: string,
 *  IMAGE_URLS: string,
 *  TEXT_IMAGE: string,
 *  OPTION: string,
 *  AI: string,
 *  BY_TEXT: string,
 *  BY_IMAGE: string,
 *  REPORT_TYPE: string,
 *  REPORT_ID: string,
 *  LIGHTBOX_ID: string,
 *  KEYWORDS: string,
 *  PROVIDER: string,
 *  SEARCHER_ID: string,
 *  LIMIT_DOWNLOAD: string,
 *  PLUGIN_AI: string,
 *  IMG_UID: string,
 * }} SEARCHER_TYPES - Searcher types.
 */
export const SEARCHER_TYPES = {
    IMAGE_ID: 'id',
    TYPE: 'type',
    TEXT: 'text',
    IMAGE_URLS: 'image',
    TEXT_IMAGE: 'textImage',
    OPTION: 'searchOption',
    AI: 'ai',
    BY_TEXT: 'byText',
    BY_IMAGE: 'byImage',
    REPORT_TYPE: 'rType',
    REPORT_ID: 'rId',
    LIGHTBOX_ID: 'lightboxId',
    KEYWORDS: 'keywords',
    PROVIDER: 'provider',
    SEARCHER_ID: 'searchId',
    LIMIT_DOWNLOAD: 'limitDownload',
    PLUGIN_AI: 'pluginAI',
    IMG_UID: IMAGE_UUID_ATTRIBUTE,
};

/**
 * Searcher options.
 * @type {{
 *  ED_CODE: string,
 *  ED_ALL: string,
 *  ED_IMGS: string,
 *  ED_VIDEOS: string,
 *  CR_CODE: string,
 *  CR_ALL: string,
 *  CR_IMGS: string,
 *  CR_VIDEOS: string,
 *  CR_ILLUSTRATIONS: string,
 *  CR_VECTORS: string,
 * }} SEARCHER_OPTIONS
 */
export const SEARCHER_OPTIONS = {
    ED_CODE: 'ed',
    ED_ALL: 'edAll',
    ED_IMGS: 'edImgs',
    ED_VIDEOS: 'edVideos',
    CR_CODE: 'cr',
    CR_ALL: 'crAll',
    CR_IMGS: 'crImgs',
    CR_VIDEOS: 'crVideos',
    CR_ILLUSTRATIONS: 'crIllustrations',
    CR_VECTORS: 'crVectors',
};

/**
 * Searcher option types.
 * @type {Array} SEARCHER_OPTION_TYPES
 */
export const SEARCHER_OPTION_TYPES = [
    SEARCHER_OPTIONS.ED_ALL,
    SEARCHER_OPTIONS.ED_IMGS,
    SEARCHER_OPTIONS.ED_VIDEOS,
    SEARCHER_OPTIONS.CR_ALL,
    SEARCHER_OPTIONS.CR_IMGS,
    SEARCHER_OPTIONS.CR_VIDEOS,
];

/**
 * Search imgs order by options.
 * @type {{
 *  SIM: string,
 *  OLD: string,
 *  NEW: string,
 *  CAP: string,
 * }} SEARCH_IMGS_ORDER_BY_OPTIONS
 */
export const SEARCH_IMGS_ORDER_BY_OPTIONS = {
    SIM: 'sim',
    OLD: 'old',
    NEW: 'new',
    CAP: 'cap',
};

/**
 * @type {string}
 */
export const DEFAULT_ORDER_BY_OPTION = SEARCH_IMGS_ORDER_BY_OPTIONS.NEW;

/**
 * Search imgs separator.
 * @type {string} SEARCH_IMGS_SEPARATOR
 */
export const SEARCH_SIM_IMGS_SEPARATOR = ':';

/**
 * Search handle by user.
 * @type {string} SEARCH_HANDLE_BY_USER
 */
export const SEARCH_HANDLE_BY_USER = 'search-handle-by-user';
